///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>
///<reference path="../../../common/security.keys.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-base.ts"/>

module Meevo.Components.Controls.SmartMover {


    import Dictionary = _.Dictionary;

    export class ReportLiabilitiesDataTemplate extends LiabilitiesDataTemplate implements IDataTemplate {

        constructor(model: Dictionary<any>, properties: string[], {criteria}, items: IListElement[] = []) {
            super(model, properties, criteria);

            if (items != null) {
                this.validation.push(
                    new RequiredValidation(this.collection, 'LABEL_REPORT_SELECT_LIABILITY_TYPE')
                );
            }
        }
    }
}